module.exports = __webpack_public_path__ + "8a0aab13967d1377cc89a8fefb7790b8.fbx";